import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { EnduserService } from 'src/app/core/services/enduser.service';
import { StorebuilderService } from 'src/app/core/services/storebuilder.service';
import { CommonService } from 'src/app/core/services/common.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ProductService } from 'src/app/core/services/product.service';

@Component({
  selector: 'app-teamstore-response',
  templateUrl: './teamstore-response.component.html',
  styleUrls: ['./teamstore-response.component.scss']
})
export class TeamstoreResponseComponent {
  isNewUser: boolean = false;
  isLaunchAction: boolean = false;
  storeId: any;
  userInfo: any;
  organizationArray: any;
  storeRequestForm: UntypedFormGroup;
  teamStore: any;
  states: any;
  shippingMethods = [{ id: 1, name: "Individual Shipping" }, { id: 2, name: "Bulk Shipping" }, { id: 3, name: "Bulk Pickup" }];
  markets: any;
  agreeToTerms: boolean = false;

  constructor(private route: ActivatedRoute, private location: Location, private endUserService: EnduserService,
    private storeBuilderService: StorebuilderService, private commonService: CommonService, private formBuilder: UntypedFormBuilder,
    private productService: ProductService, private router: Router
  ) { }

  ngOnInit() {
    // this.createStoreRequestForm()
    // this.getStates()
    // this.getMarkets()
    // this.route.queryParams.subscribe(params => {
    //   this.isNewUser = params['newUser'] === 'true';
    //   this.isLaunchAction = params['launch'] === 'true';
    //   this.storeId = params['storeId'];

    //   if (this.storeId && this.isNewUser) {
    //     this.getTeamStore(this.storeId)
    //   }
    // });
    // //this.commonService.postHeightToParent("medium") 
    // this.commonService.postIframeHeight();


    
  }

  goBack() {
    this.location.back();
  }

  termsChanged() {
    this.agreeToTerms = !this.agreeToTerms
  }

  getTeamStore(teamStoreId) {
    this.commonService.toggleLoading(true)
    this.storeBuilderService.getTeamStore(teamStoreId).subscribe(response => {
      this.commonService.toggleLoading(false)
      this.teamStore = response.data;

      this.storeRequestForm.setValue({
        id: this.teamStore.id,
        stage: this.teamStore.stage,
        isUserExists: true,
        name: this.teamStore.name,
        firstName: (this.teamStore.firstName || ''),
        lastName: (this.teamStore.lastName || ''),
        emailId: this.teamStore.emailId,
        phoneNumber: this.teamStore.phoneNumber,
        organizationName: this.teamStore.organizationName,
        shippingPreference: this.teamStore.shippingPreference,
        marketId: this.teamStore.marketId,
        shipToState: this.teamStore.shipToState,
        agreeToTerms: this.teamStore?.agreeToTerms ?? false
      });

      Object.keys(this.storeRequestForm.controls).forEach(controlName => {
        if (controlName !== 'agreeToTerms') {
          this.storeRequestForm.get(controlName)?.disable();
        }
      });

      this.getOrganisationByUser()
    },
      error => {
        this.commonService.toggleLoading(false)
        this.commonService.openErrorSnackBar(error.message, "");
      });
  }

  getOrganisationByUser() {
    if (this.teamStore.emailId) {
      this.endUserService.getUserInfoUsingEmaiId(this.teamStore.emailId).subscribe(response => {
        this.userInfo = response.data;
        this.organizationArray = this.userInfo.organizations
      })
    }
  }

  getStates() {
    this.endUserService.getAllStates().subscribe(response => {
      if (response.data != null) {
        this.states = response.data;
      }
    });
  }

  getMarkets() {
    this.productService.getAllProductGroups({}).subscribe(
      (response) => {
        this.markets = response.body.data;
      },
      (error) => {
      }
    );

  }

  createStoreRequestForm() {
    this.storeRequestForm = this.formBuilder.group({
      id: '',
      stage: '',
      isUserExists: '',
      name: '',
      firstName: '',
      lastName: '',
      emailId: '',
      phoneNumber: '',
      organizationName: '',
      shippingPreference: '',
      marketId: '',
      shipToState: '',
      agreeToTerms: false
    });
  }

  onSubmit() {
    if (this.storeRequestForm.value.agreeToTerms) {
      this.goToMyStores()
    } else {
      this.commonService.openWarningSnackBar('You must agree to the terms before proceeding.', '');
      this.storeRequestForm.markAllAsTouched();
    }
  }

  goToMyStores() {
    if (this.isNewUser) {
      window.parent.postMessage("open guest login", "*");
      window.parent.postMessage("action - goto profile", "*");
    }
    else {
      this.router.navigate(['/enduser/useraccount/my-stores']);
    }

  }

}
